// extracted by mini-css-extract-plugin
export default {"Video":"Home_Video__yhmAk","FadeEffect":"Home_FadeEffect__oc9Ts","fade":"Home_fade__v42ft","paragraph":"Home_paragraph__U9elD","sec2":"Home_sec2__7fwL3"};